/**
 * Thanh CTA dính đáy (chỉ mobile) — người mới cuộn đọc thông tin tới đâu cũng tải được ngay.
 * Desktop đã có QR trong hero nên ẩn thanh này.
 */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

export default function DownloadStickyCta({ storeUrl, refCode }) {
    if (!storeUrl) return null;

    return (
        <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-surface/95 backdrop-blur border-t border-line px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
            <a
                href={storeUrl}
                className="flex items-center justify-center gap-2 w-full rounded-2xl bg-gradient-to-r from-[#ff7a45] to-[#ff544f] text-white font-bold py-3 shadow-lg active:scale-95 transition-transform"
            >
                <FontAwesomeIcon icon={faDownload} />
                Tải App Longhousee miễn phí
            </a>
            {refCode ? (
                <p className="text-[11px] text-content-3 text-center mt-1.5">
                    Mã giới thiệu <strong>{refCode}</strong> sẽ tự điền khi bạn đăng ký
                </p>
            ) : null}
        </div>
    );
}
